<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Reservation" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Type" v-model="entity.reservation_type_id" :options="types" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Gentag" v-model="entity.frame" :options="[
						{
							value: 'single',
							label: 'Nej'
						},
						{
							value: 'repeat',
							label: 'Ja'
						}
					]"/>
					<form-line-layout v-show="entity.frame == 'single'">
						<date-select-view label="Fra" v-model="entity.start_date" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.start_time" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout v-show="entity.frame == 'single'">
						<date-select-view label="Til" v-model="entity.end_date" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.end_time" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout v-show="entity.frame == 'repeat'">
						<date-select-view label="Aktiv periode" v-model="entity.start_date" :controller="$store.state.popupController" />
						<date-select-view label="" v-model="entity.end_date" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout v-show="entity.frame == 'repeat'">
						<clock-select-view label="Fra" v-model="entity.start_time" :controller="$store.state.popupController" />
						<clock-select-view label="Til" v-model="entity.end_time" :controller="$store.state.popupController" />
					</form-line-layout>
				</div>
				<div v-show="active == 'details' && entity.frame == 'repeat'" style="padding: 0;">
					<check-list-view :options="[
						{
							label: 'Mandag',
							value: 1
						},
						{
							label: 'Tirsdag',
							value: 2
						},
						{
							label: 'Onsdag',
							value: 3
						},
						{
							label: 'Torsdag',
							value: 4
						},
						{
							label: 'Fredag',
							value: 5
						},
						{
							label: 'Lørdag',
							value: 6
						},
						{
							label: 'Søndag',
							value: 0
						}
					]" v-model="entity.repeat" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Status" v-model="entity.status" :options="status" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger" :height="200" :optional="true" v-model="entity.note" />
				</div>
				<div v-show="active == 'employees'" style="padding: 0;">
					<check-list-view :options="_employees" v-model="entity.employees" />
				</div>
				<div v-show="active == 'vehicles'" style="padding: 0;">
					<check-list-view :options="_vehicles" v-model="entity.vehicles" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import ReservationModel from '../model/Reservation'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				entity: {},

				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				types: [],
				status: [],
				employees: [],
				vehicles: [],
			};
		},
		watch: {
			'entity.from': function (n) {
				if (n > this.entity.to) {
					this.entity.to = n;
				}
			},
			'entity.to': function (n) {
				if (n < this.entity.from) {
					this.entity.from = n;
				}
			},
			'entity.due_from': function (n) {
				this.entity.end = n;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'employees',
						label: 'Medarbejdere'
					},
					{
						name: 'vehicles',
						label: 'Køretøjer'
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function () {}
			},
			value: {
				type: Object,
				default() {
					return Object.assign({}, ReservationModel);
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.entity);
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.entity = merge({}, this.value);

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/planning/reservations/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/planning/reservations/status/')
				.then(function (r) {
					self.status = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/employees/')
				.then(function (r) {
					self.employees = r.data._items;
					//self.departments = r.data._items;

					
				});

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					self.vehicles = r.data._items;
					//self.departments = r.data._items;
				});

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
